import gql from 'graphql-tag';

const NAME =
  'compositions_CaseInboundProgramPanel_updateCaseInboundProgramNumberID';

export default gql`
  mutation ${NAME} (
    $caseId: ID!
    $inboundProgramNumberId: ID,
  ) {
    updateCase(
      input: {
        id: $caseId,
        patch: {
          inboundProgramNumberId: $inboundProgramNumberId,
          inboundProgramShipTo: null
        },
      },
    ) {
      case {
        id
        inboundProgramNumber {
          id
          billTo
          isUsxpress
          customerName
          defaultCustomer { id name }
          inboundProgramAccountType
          locations {
            ... on Dealer {
              id
              name
              billTo
              shipTo
              displayAddress { city province }
            }
            ... on Customer {
              id
              city
              name
              state
              shipTo
              billTo
            }
          }
          tollFreeNumber
          assetValidationFields
          requiresAssetValidation
          assetValidationInstructions
          requiresValidationForAssetTypes {
            type
            requirements
          }
          assetValidationFailureInstructions
        }
        inboundProgramShipTo
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/compositions/CaseInboundProgramPanel/withInboundProgramSelect/updateCaseInboundProgramNumberIDMutation.js